import { getPoranaytteetByTarkastuskohdeV2, getTestitV2, getTestiCaptionV2 } from '../../../api/api';

// v2 counterpart of RenderOhuthieBlock.js. Styling constants below are a
// deliberate copy (not imported) — v1's PDF output stays untouched. v2's
// Ohuthie block is tarkastuskohde-scoped (spans every rakenneosa under it,
// not just one), so eligibility + row-fetching mirrors what the live
// useTestiTypeV2 hook already does: list samples, filter by testi type,
// fetch each eligible sample's testi row.

const TYYPPI = 'Ohuthie';

const GREEN = '#04aa00';
const F = { font: 'Lato', fontSize: 8 };
const TH = { ...F, bold: true, color: '#fff', fillColor: GREEN, alignment: 'center', margin: [0, 2, 0, 2] };
const TD = (opts = {}) => ({ ...F, alignment: 'center', ...opts });

function v(val) { return (val !== null && val !== undefined && val !== '') ? String(val) : '—'; }

const tableLayout = {
  hLineWidth: () => 0.5,
  vLineWidth: () => 0.5,
  hLineColor: () => '#adb5bd',
  vLineColor: () => '#adb5bd',
  paddingLeft:   () => 4,
  paddingRight:  () => 4,
  paddingTop:    () => 3,
  paddingBottom: () => 3,
  fillColor: (row) => row > 0 && row % 2 === 0 ? '#f8f9fa' : null,
};

const headerRow = [
  { text: 'Tunnus',               ...TH },
  { text: 'Näytteenottokohta',    ...TH },
  { text: 'Laatu-\nluokka',       ...TH },
  { text: 'Kunto-\nluokka',       ...TH },
  { text: 'Pakkas-\nrapautu-\nneisuus', ...TH },
];

export async function renderOhuthieBlockV2({ block, content, tableCounter }) {
  const nav = block?.data?.nav ?? {};
  if (!nav.tkId) return;

  let samples;
  try { samples = (await getPoranaytteetByTarkastuskohdeV2(nav.tkId)).data ?? []; }
  catch (e) { console.warn('[RenderOhuthieBlockV2] failed to fetch poränäytteet:', e); return; }

  const eligible = samples.filter(s => (s.testi || '').toLowerCase().includes(TYYPPI.toLowerCase()));
  if (!eligible.length) return;

  const rows = (await Promise.all(eligible.map(async s => {
    let testit;
    try { testit = (await getTestitV2(s.id)).data ?? []; } catch { return null; }
    const t = testit.find(x => x.tyyppi === TYYPPI);
    if (!t) return null;
    return { tunnus: s.nayte_tunnus, _rakenneosa: s.rakenneosa?.nimi ?? '', ...t.arvo };
  }))).filter(Boolean);
  if (!rows.length) return;

  const tblNum = tableCounter ? ++tableCounter.value : null;
  const dataRows = rows.map(row => [
    TD({ text: v(row.tunnus) }),
    TD({ text: v(row._rakenneosa) }),
    TD({ text: v(row.laatuluokka) }),
    TD({ text: v(row.kuntoluokka) }),
    TD({ text: v(row.pakkasrapautuneisuus) }),
  ]);

  // testi_caption is one per (tarkastuskohde, tyyppi), shared by every
  // sample row in this table — see testi_caption on the backend. Rich-text
  // captions (TaulukkoFooter) are persisted as JSON.stringify({value, html});
  // a bare string (pre-rich-text data) passes through unchanged.
  const readCap = (raw) => {
    if (!raw) return '';
    try {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object' && 'value' in parsed) return (parsed.value ?? '').trim();
    } catch { /* plain string */ }
    return String(raw).trim();
  };
  let captionRow;
  try { captionRow = (await getTestiCaptionV2(nav.tkId, TYYPPI)).data; } catch { /* fall back below */ }
  // No fallback — an empty caption stays empty in the PDF. The table
  // number still always shows.
  const captionText = readCap(captionRow?.caption);

  content.push({
    stack: [
      {
        table: {
          headerRows: 1,
          widths: ['*', '*', '*', '*', '*'],
          body: [headerRow, ...dataRows],
        },
        layout: tableLayout,
        margin: [0, 5, 0, 0],
      },
      ...(tblNum !== null ? [{
        text: captionText
          ? [{ text: `Taulukko ${tblNum}. `, bold: true }, { text: captionText, bold: false }]
          : [{ text: `Taulukko ${tblNum}.`, bold: true }],
        font: 'Lato', fontSize: 9,
        margin: [0, 4, 0, 0],
      }] : []),
    ],
    margin: [0, 0, 0, 15],
  });
}
